module.exports = __webpack_public_path__ + "static/media/sangmyung.38a5f1c5.png";